export const priceCalculationTypes = {
    quotation: 1,
    order: 2
}

export const priceCalculationTypeText = {
    quotation: "Quotation",
    order: "Order"
}